import { render, staticRenderFns } from "./DialogWindow.vue?vue&type=template&id=730aef7f&scoped=true&"
import script from "./DialogWindow.vue?vue&type=script&lang=js&"
export * from "./DialogWindow.vue?vue&type=script&lang=js&"
import style0 from "./DialogWindow.vue?vue&type=style&index=0&id=730aef7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730aef7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAlert,VBtn,VDialog})
